export const GET_LIST_FILTER = 'GetListFilter/Success';
export const LOADING_GET_LIST_FILTER = 'GetListFilter/Loading';

export const GET_LIST_TOTAL_PIPELINES = 'GetListTotalPipelines/Success';
export const LOADING_GET_LIST_TOTAL_PIPELINES = 'GetListTotalPipelines/Loading';

export const GET_LIST_RM = 'GetListRM/Success';
export const LOADING_GET_LIST_RM = 'GetListRM/Loading';

export const INFINITE_SCROLL_LIST_RM = 'InfiniteScrollListRM/Success';
export const LOADING_INFINITE_SCROLL_LIST_RM = 'InfiniteScrollListRM/Loading';

export const GET_DETAIL_RM = 'GetDetailRM/Success';
export const LOADING_GET_DETAIL_RM = 'GetDetailRM/Loading';
